import Chart from './Chart';
import Formatter from '../Formatter';

class LineChart extends Chart {
  /**
   * Construir el objeto para la gráfica
   */
  lineChartBuild() {
    const elthis = this;

    return {
      colors: Chart.getColorPalette(),
      chart: {
        type: this.getChartType('line'),
        zoomType: 'x',
        height: this.height,
      },
      title: {
        text:
          this.chartObject.Titulo || this.chartObject.Titulo === ''
            ? this.chartObject.Titulo
            : this.chartObject.title.text,
      },
      subtitle: {
        text:
          this.chartObject.STitulo || this.chartObject.STitulo === ''
            ? this.chartObject.STitulo
            : this.chartObject.subtitle.text,
      },
      xAxis:
        this.chartObject.xAxis[0] && this.chartObject.xAxis[0].categories
          ? this.chartObject.xAxis
          : {
              categories: this.chartObject.xAxis,
              crosshair: true,
              title: this.getXAxisName(),
              labels: {
                rotation: this.getRotationLabel(),
              },
            },
      yAxis: Array.isArray(this.chartObject.yAxis)
        ? this.chartObject.yAxis
        : {
            ...(this.getTicksData() ? this.getTicksData() : { min: 0 }),
            title: {
              text: this.chartObject.yAxis
                ? typeof this.chartObject.yAxis === 'string'
                  ? this.chartObject.yAxis
                  : this.chartObject.yAxis.title.text
                : '',
            },
            ...this.getPlotBands(),
            labels: {
              style: {
                color: '#6e6e70',
              },
            },
            opposite: false,
            ...this.getPlotLines(),
            ...this.getTicksData(),
          },
      tooltip: this.showValueSuffixFromOrigin()
        ? {}
        : {
            formatter: function () {
              return elthis.getTooltip(this);
            },
            useHTML: true,
          },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: this.showDataLabels(),
            formatter: function () {
              let suffix = elthis.getSuffix(this.series);

              return this.y != 0
                ? `${Formatter.formatMoney(
                    this.y,
                    elthis.getDataNumbersDecimal()
                  )} ${elthis.percent ? '%' : suffix}`
                : null;
            },
          },
          enableMouseTracking: this.isEnableMouseTracking(),
        },
      },
      series: this.chartObject.values
        ? this.chartObject.values
        : this.chartObject.series,
    };
  }
}

export default LineChart;
